import axios from 'axios';

// Client dédié aux deux routes publiques d'invitation (payor_proxy/008).
// Volontairement hors de components/Config/api.service.js : axiosInstance
// pose withCredentials:true et redirige sur /403 dès un premier refus
// (avant même le 401/refresh), ce qui éjecterait un employé non authentifié.
// Ici : pas de cookie de session envoyé, pas d'intercepteur, pas de
// redirection — le composant lit lui-même error.response.
const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:5003';

const invitationClient = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
});

// Corps construits clé par clé : l'allowlist du proxy (app.py:1283) rejette
// en 400 sec toute clé en trop — un objet relayé tel quel casserait au
// premier champ superflu (ex. la confirmation du mot de passe).
export async function verifierJeton(jeton, country) {
    const response = await invitationClient.post('/invitation-portail/verifier', { jeton, country });
    return response.data;
}

export async function definirMotDePasse(jeton, motDePasse, country) {
    const response = await invitationClient.post('/invitation-portail/mot-de-passe', {
        jeton,
        mot_de_passe: motDePasse,
        country,
    });
    return response.data;
}
